export default function redirect(url){
	document.location.href = url
}



// WEBPACK FOOTER //
// ./client/lib/redirect.js